import request from '../request'

export const INVENTORY_OUTBOUND_FIFO_PARAM = 'inventory-outbound-fifo'
export const INVENTORY_QTY_SHOW_SUPPLIER_PARAM = 'inventory-qty-show-supplier'
export const INVENTORY_BARCODE_ENABLED_PARAM = 'inventory-barcode-enabled'
export const SALE_SHIPPING_NOTICE_REQUIRED_PARAM = 'sale-shipping-notice-required'
export const PURCHASE_ARRIVAL_NOTICE_REQUIRED_PARAM = 'purchase-arrival-notice-required'
export const PURCHASE_IQC_REQUIRED_PARAM = 'purchase-iqc-required'
export const SALE_PRICE_LIST_ENABLE_PARAM = 'sale-price-list-enable'
export const SALE_CREDIT_CHECK_ENABLE_PARAM = 'sale-credit-check-enable'

/** 已纳入业务设置的配置编码（统一走 /sys/config/queryCode） */
export const BUSINESS_CONFIG_CODES = new Set([
  INVENTORY_OUTBOUND_FIFO_PARAM,
  INVENTORY_QTY_SHOW_SUPPLIER_PARAM,
  INVENTORY_BARCODE_ENABLED_PARAM,
  SALE_SHIPPING_NOTICE_REQUIRED_PARAM,
  PURCHASE_ARRIVAL_NOTICE_REQUIRED_PARAM,
  PURCHASE_IQC_REQUIRED_PARAM,
  SALE_PRICE_LIST_ENABLE_PARAM,
  SALE_CREDIT_CHECK_ENABLE_PARAM
])

function isBusinessConfig(paramCode) {
  return paramCode && (BUSINESS_CONFIG_CODES.has(paramCode) || (
    paramCode.startsWith('inventory-') ||
    paramCode.startsWith('sale-') ||
    paramCode.startsWith('purchase-') ||
    paramCode.startsWith('production-') ||
    paramCode.startsWith('finance-') ||
    paramCode.startsWith('workflow-') ||
    paramCode.startsWith('plm-')
  ))
}

/**
 * 按编码查询配置：业务设置项走 /sys/config/queryCode，遗留参数走 /sys/params/by-code
 * 返回统一字段 paramValue（兼容原系统 paramValue1）
 */
export function queryParamByCode(paramCode) {
  if (isBusinessConfig(paramCode)) {
    return request.get('/sys/config/queryCode', { params: { configCode: paramCode } }).then(res => {
      const data = res.data || {}
      const value = data.paramValue != null ? data.paramValue : (data.paramValue1 || '')
      return {
        ...res,
        data: {
          ...data,
          paramValue: value,
          paramValue1: value
        }
      }
    })
  }
  return request.get('/sys/params/by-code', { params: { code: paramCode } }).then(res => {
    const data = res.data || {}
    const value = data.paramValue != null ? data.paramValue : ''
    return {
      ...res,
      data: {
        ...data,
        paramValue: value,
        paramValue1: value
      }
    }
  })
}

export function isConfigEnabled(paramCode) {
  return queryParamByCode(paramCode).then(res => {
    const value = res.data && (res.data.paramValue != null ? res.data.paramValue : res.data.paramValue1)
    return String(value || '').trim() === '1'
  }).catch(() => false)
}
